import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../assets/js/lang'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    en: 1,
    username: localStorage.getItem('username'),
    token: '',
    isLogin: false,
    num:0
  },
  mutations: {
    CHANGE_lANG (state) {
      if (i18n.locale == 'zh') {
        state.en = 1
      } else if(i18n.locale == 'en'){
        state.en = 2
      }else {
        state.en = 3
      }
    },
    USER_STATUS (state, user) {
      if (user) {
        state.isLogin = true
        state.username = user.username
        state.token = user.token
      } else {
        state.username = ''
        state.isLogin = false
        state.token = ''
      }
    },
    ADD_NUM(state,num){
      state.num = state.num+num
    }
  },
  actions: {
    changeLang: ({commit}) => {commit('CHANGE_lANG')},

    userStatus: ({commit}, user) => {commit('USER_STATUS', user)},
    
    addNum(cotext,num){cotext.commit('ADD_NUM',num)}
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js